import { RouterModule, Routes } from "@angular/router";
import { NgModule } from "@angular/core";
import { ContributionComponent } from "./contribution.component";
import { ContributionLayoutComponent } from "./contribution.layout";
import { TokenSaleDetailsComponent } from "./token-sale-details/token-sale-details.component";
import { RecentTransactionsComponent } from "./recent-transactions/recent-transactions.component";

export const routes: Routes = [
    {
        path: "",
        component: ContributionLayoutComponent,
        children: [
            {
                path: "",
                component: ContributionComponent,
            },
            {
                path: "tokenSaleDetails",
                component: TokenSaleDetailsComponent,
            },
        ],
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class ContributionRoutingModule {}
